import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AlertController, IonicModule, ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';

/**
 *  ÁGAZATI ALAPVIZSGÁK osztályonként (backend/agazati-alapvizsga.js).
 *
 *  Szkt. 91. § (4): az ágazati alapvizsga teljesítését a bizonyítványba kell bejegyezni. A sikeres
 *  (vagy mentesült – Szkr. 256. § (3)) vizsga szövege a vizsga tanévének év végi bizonyítványába kerül
 *  (szakképző intézmény bizonyítványa, szakképzési sablon).
 */
@Component({
  selector: 'app-agazati-alapvizsga-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  template: `
<ion-header>
  <ion-toolbar>
    <ion-title>Ágazati alapvizsgák</ion-title>
    <ion-buttons slot="end"><ion-button (click)="bezar()">Bezárás</ion-button></ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <p class="halvany">
    Az ágazati alapvizsga teljesítését a bizonyítványba kell bejegyezni (Szkt. 91. § (4)): a sikeres vagy
    mentesült vizsga a vizsga tanévének év végi bizonyítványába kerül. Az eredmény (%) a szakmai vizsgába
    legalább 10%-kal beszámít (Szkr. 290. § (1a)); sikertelen alapvizsgával a tanuló nem léphet magasabb
    évfolyamba (Szkr. 256. § (1)) – ezt a szokásos záradék rögzíti.
  </p>
  <ion-item lines="full">
    <ion-select label="Osztály" label-placement="stacked" interface="popover" [(ngModel)]="osztaly" (ionChange)="toltes()">
      <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">{{ o.osztaly }}</ion-select-option>
    </ion-select>
  </ion-item>
  <div *ngIf="betolt" class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></div>

  <ng-container *ngIf="!betolt">
    <p class="halvany" *ngIf="osztaly && !tanulok.length">Az osztálynak nincs tanulója.</p>
    <div class="tanulo" *ngFor="let t of tanulok">
      <div class="fej">
        <b>{{ t.nev || t.oktazon }}</b>
        <ion-button size="small" fill="clear" (click)="uj(t)"><ion-icon slot="start" name="add-outline"></ion-icon>Vizsga</ion-button>
      </div>
      <div class="vizsga" *ngFor="let v of t.vizsgak" [class.sikertelen]="v.eredmeny === 'sikertelen'">
        <div>
          {{ v.agazat }} · {{ v.vizsga_datum ? (v.vizsga_datum | date:'yyyy.MM.dd.') : '' }}
          · {{ eredmenyNev(v.eredmeny) }}{{ v.szazalek != null ? ' (' + v.szazalek + '%)' : '' }}{{ v.vizsga_fajta !== 'rendes' ? ' · ' + fajtaNev(v.vizsga_fajta) : '' }}
          · bizonyítvány: {{ v.tanev }}
          <div class="halvany" *ngIf="v.bejegyzes">„{{ v.bejegyzes }}”</div>
          <div class="halvany" *ngIf="!v.bejegyzes">Nem kerül a bizonyítványba (sikertelen).</div>
        </div>
        <div class="gombok">
          <ion-button size="small" fill="outline" (click)="szerkeszt(t, v)">Módosítás</ion-button>
          <ion-button size="small" fill="clear" color="danger" (click)="torol(v)">Törlés</ion-button>
        </div>
      </div>

      <ion-list *ngIf="urlap && urlap.oktazon === t.oktazon" class="urlap" lines="full">
        <ion-item>
          <ion-select label="Ágazat (Szakmajegyzék)" label-placement="stacked" interface="popover" [(ngModel)]="urlap.agazat">
            <ion-select-option *ngFor="let a of agazatValasztek()" [value]="a">{{ a }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-input label="Választott szakma (ha már ismert)" label-placement="stacked" [(ngModel)]="urlap.szakma"></ion-input>
        </ion-item>
        <ion-item>
          <ion-select label="Eredmény" label-placement="stacked" interface="popover" [(ngModel)]="urlap.eredmeny">
            <ion-select-option value="sikeres">Sikeres</ion-select-option>
            <ion-select-option value="sikertelen">Sikertelen</ion-select-option>
            <ion-select-option value="mentesult">Mentesült (Szkr. 256. § (3))</ion-select-option>
          </ion-select>
        </ion-item>
        <ng-container *ngIf="urlap.eredmeny !== 'mentesult'">
          <ion-item>
            <ion-input type="date" label="A vizsga napja" label-placement="stacked" [(ngModel)]="urlap.vizsga_datum"></ion-input>
          </ion-item>
          <ion-item>
            <ion-select label="A vizsga fajtája" label-placement="stacked" interface="popover" [(ngModel)]="urlap.vizsga_fajta">
              <ion-select-option value="rendes">Rendes vizsga</ion-select-option>
              <ion-select-option value="javito">Javítóvizsga</ion-select-option>
              <ion-select-option value="potlo">Pótlóvizsga</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-input type="number" min="0" max="100" label="Eredmény (%)" label-placement="stacked" [(ngModel)]="urlap.szazalek"></ion-input>
          </ion-item>
          <ion-item>
            <ion-input label="A vizsgabizottság elnöke (kamarai delegált)" label-placement="stacked" [(ngModel)]="urlap.elnok"></ion-input>
          </ion-item>
        </ng-container>
        <ion-item *ngIf="urlap.eredmeny === 'mentesult'">
          <ion-input label="A mentesülés oka (részszakma / beszámított előzetes tudás)" label-placement="stacked" [(ngModel)]="urlap.mentesites_oka"></ion-input>
        </ion-item>
        <ion-item>
          <ion-input label="Bizonyítvány tanéve (üresen: a vizsga napjából)" label-placement="stacked" [(ngModel)]="urlap.tanev" placeholder="pl. 2025/2026"></ion-input>
        </ion-item>
        <ion-item>
          <ion-input label="Jegyzőkönyv / igazolás száma" label-placement="stacked" [(ngModel)]="urlap.igazolas_szam"></ion-input>
        </ion-item>
        <ion-item>
          <ion-input label="Megjegyzés" label-placement="stacked" [(ngModel)]="urlap.megjegyzes"></ion-input>
        </ion-item>
        <div class="gombok">
          <ion-button fill="clear" (click)="urlap = null">Mégse</ion-button>
          <ion-button (click)="ment()" [disabled]="fut">{{ fut ? 'Mentés…' : 'Mentés' }}</ion-button>
        </div>
      </ion-list>
    </div>
  </ng-container>
</ion-content>`,
  styles: [`
    .halvany { color: var(--ion-color-medium); font-size: 0.85rem; }
    .tanulo { border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25); padding: 8px 0; }
    .fej { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .vizsga { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; margin: 4px 0 4px 8px;
              border-left: 4px solid var(--ion-color-success); padding: 4px 10px; }
    .vizsga.sikertelen { border-left-color: var(--ion-color-danger); }
    .urlap { margin: 6px 0 6px 8px; }
    .gombok { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 6px; }
  `],
})
export class AgazatiAlapvizsgaModalComponent implements OnInit {
  @Input() intezmeny = '';
  @Input() osztalyok: any[] = [];
  @Input() osztaly: string | null = null;
  tanulok: any[] = [];
  agazatok: string[] = [];
  betolt = false;
  fut = false;
  urlap: any = null;

  constructor(private http: HttpClient, private data: DataService, private modal: ModalController, private alert: AlertController) {}

  ngOnInit() { if (this.osztaly) this.toltes(); }
  bezar() { this.modal.dismiss(); }

  /** A Szakmajegyzék ágazatai + a módosított bejegyzés régebbi (listán kívüli) ágazata. */
  agazatValasztek(): string[] {
    const a = this.urlap?.agazat;
    return a && !this.agazatok.includes(a) ? [a, ...this.agazatok] : this.agazatok;
  }
  eredmenyNev(e: string) { return e === 'sikeres' ? 'sikeres' : e === 'mentesult' ? 'mentesült' : 'sikertelen'; }
  fajtaNev(f: string) { return f === 'javito' ? 'javítóvizsga' : f === 'potlo' ? 'pótlóvizsga' : 'rendes vizsga'; }

  async toltes() {
    if (!this.osztaly) return;
    this.betolt = true;
    this.urlap = null;
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/agazati-alapvizsga/lista/${this.intezmeny}`, { params: { osztaly: String(this.osztaly) } }));
      this.tanulok = r?.tanulok || [];
      this.agazatok = r?.agazatok || [];
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Nem sikerült betölteni az ágazati alapvizsgákat.', 'error');
    } finally { this.betolt = false; }
  }

  uj(t: any) {
    //  Az osztálytárs legutóbbi ágazata jó kiindulás (egy osztály jellemzően egy ágazat).
    const utolso = this.tanulok.flatMap((x) => x.vizsgak || []).pop();
    this.urlap = { oktazon: t.oktazon, agazat: utolso?.agazat || '', szakma: '', eredmeny: 'sikeres', vizsga_datum: '', vizsga_fajta: 'rendes',
      szazalek: null, elnok: utolso?.elnok || '', mentesites_oka: '', tanev: '', igazolas_szam: '', megjegyzes: '' };
  }
  szerkeszt(t: any, v: any) {
    this.urlap = { ...v, oktazon: t.oktazon, vizsga_datum: v.vizsga_datum || '' };
  }

  async ment() {
    if (!this.urlap) return;
    this.fut = true;
    try {
      await firstValueFrom(this.http.post(`/api/agazati-alapvizsga/mentes/${this.intezmeny}`, this.urlap));
      this.data.sendToast('Ágazati alapvizsga mentve.', 'success');
      await this.toltes();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally { this.fut = false; }
  }

  async torol(v: any) {
    const a = await this.alert.create({
      header: 'Ágazati alapvizsga törlése',
      message: `${v.agazat} – ${v.vizsga_datum || v.tanev}. A már kiállított bizonyítványt nem módosítja.`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'ok' }],
    });
    await a.present();
    if ((await a.onDidDismiss()).role !== 'ok') return;
    try {
      await firstValueFrom(this.http.delete(`/api/agazati-alapvizsga/tetel/${v.id}`, { params: { intezmeny: this.intezmeny } }));
      await this.toltes();
    } catch (e: any) { this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error'); }
  }
}
